import React from "react";

import clsx from "clsx";
import { useNavigate } from "react-router-dom";

import {
  DataTypeProvider,
  type DataTypeProviderProps,
} from "@devexpress/dx-react-grid";

const AdDetailssDataFormatter = ({
  row,
}: DataTypeProvider.ValueFormatterProps) => {
  const navigate = useNavigate();
  const updatePath = () => {
    const url = new URL(window.location.href);
    const searchParams = row.link.Name.split("?")[0];

    const id = searchParams.split("/")[1];
    url.searchParams.set("flyoutPath", id);
    navigate(url.pathname + url.search, { replace: true });
  };

  if (row?.link.Name) {
    return (
      <i
        className={clsx(
          "fa-regular fa-sharp fa-memo cursor-pointer text-xl",
          "flex justify-center text-primary",
        )}
        onClick={updatePath}
      />
    );
  }

  return null;
};

export const AdDetailsTypeProvider = (props: DataTypeProviderProps) => (
  <DataTypeProvider formatterComponent={AdDetailssDataFormatter} {...props} />
);
